import { render, staticRenderFns } from "./PayMoney.vue?vue&type=template&id=3545cfae&scoped=true"
import script from "./PayMoney.vue?vue&type=script&lang=js"
export * from "./PayMoney.vue?vue&type=script&lang=js"
import style0 from "./PayMoney.vue?vue&type=style&index=0&id=3545cfae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545cfae",
  null
  
)

export default component.exports